import type { PathParams } from './paths';

export const parseSearchParams = (args?: PathParams) =>
  '?' + new URLSearchParams(args).toString();
